import type { ComponentProps } from 'react';
import { cn } from '@/shared/lib/cn';
import { useFormField } from './use-form-field';

export function FormLabel({ className, ...props }: ComponentProps<'label'>) {
  const { controlId } = useFormField();
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: htmlFor comes from the FormItem id that FormControl puts on the control.
    <label
      data-slot="form-label"
      htmlFor={controlId}
      className={cn('font-medium', className)}
      {...props}
    />
  );
}
